import { AdminAppState, AuthState } from '../../state';

export const getAuth = (store: AdminAppState): AuthState => store.auth;
